/**
 * Traduce el error de una llamada a la API en algo que el usuario pueda leer.
 *
 * El backend corre con server.error.include-message=always, asi que el cuerpo
 * del error trae el "message" de CUALQUIER excepcion, incluidas las del driver
 * de MySQL. Sin pasar por aqui, al usuario le acaba saliendo la sentencia SQL
 * completa en pantalla.
 *
 * Se usa desde los formularios que guardan: producto, empresa y lugar.
 */

/** Nombre de columna -> como se llama ese campo en la pantalla */
const CAMPOS = {
  descripcion: 'Descripción',
  ubicacion: 'Ubicación',
  nombre: 'Nombre',
  producto: 'Nombre del producto',
  empresa: 'Nombre de la empresa',
  categoria: 'Categoría',
  horario: 'Horario',
  ciudad: 'Ciudad',
  pais: 'País',
  departamento: 'Departamento',
  telefono: 'Teléfono'
}

export function mensajeDeError(error, respaldo = 'No se pudo guardar') {
  const datos = error?.response?.data
  const mensaje = typeof datos === 'string' ? datos : datos?.message

  if (!mensaje) {
    return error?.message || respaldo
  }

  // El unico error de base que el usuario puede arreglar solo: se le dice que
  // campo acortar en vez de mostrarle el UPDATE entero.
  if (/Data too long|Data truncation/i.test(mensaje)) {
    const columna = /column '(\w+)'/i.exec(mensaje)
    const campo = columna ? (CAMPOS[columna[1]] || columna[1]) : 'uno de los campos'
    return `El texto de ${campo} es demasiado largo. Acórtalo e intenta de nuevo.`
  }

  // Choque de clave unica: el correo repetido es el caso real hoy
  if (/Duplicate entry/i.test(mensaje)) {
    return 'Ya existe un registro con esos datos.'
  }

  // Cualquier otro error del driver: no tiene sentido enseñarle SQL a nadie
  if (/could not execute statement|SQL \[|constraint \[/i.test(mensaje)) {
    return respaldo
  }

  return mensaje
}

export default mensajeDeError
